import React from "react";
import "../aseets/css/Footer.css";
import logo from "../aseets/gallery/GM_logo.png";

import insta from '../aseets/SocialIcons/IG.png';
import fb from '../aseets/SocialIcons/FB.png';
import linkedin from '../aseets/SocialIcons/IN.png';
import YT from '../aseets/SocialIcons/YT.png';

import { Link } from "react-router-dom";


const Footer = () => {
  return (
    <footer className="gm-footer">
      <div className="gm-footer-container">

        {/* LEFT */}
        <div className="gm-footer-brand">
         <Link to="/"><img src={logo} alt="Global Manch" className="gm-footer-logo" /> </Link>

          <p className="gm-footer-tag">
            India’s Leading<br />Digital Marketing Agency
          </p>

          <span className="gm-footer-connect">CONNECT</span>

          <div className="gm-footer-socials">
            <a href="#"><img src={fb}></img></a>
            <a href="#"><img src={insta}></img></a>
            <a href="#"><img src={linkedin}></img></a>
            <a href="#"><img src={YT}></img></a>
            
          </div>

          <div className="gm-footer-search">
            <input type="text" placeholder="Search..." />
            <span className="gm-footer-search-icon">🔍</span>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div className="gm-footer-col">
          <h4 className="gm-footer-title">Quick Links</h4>
          <ul>
            <li>Home</li>
            <li>About</li>
            <li>Services</li>
            <li>Industry</li>
            <li>Products</li>
            <li>Contact</li>
            <li>Life at Global Manch</li>
            <li>Career</li>
            <li>FAQ</li>
            <li>Blogs</li>
          </ul>
        </div>

        {/* SERVICES */}
        <div className="gm-footer-col">
          <h4 className="gm-footer-title">Services</h4>
          <ul>
            <li>Graphics Designing</li>
            <li>Performance Marketing</li>
            <li>Website Development</li>
            <li>E-Commerce Development</li>
            <li>Email & WhatsApp Marketing</li>
            <li>Podcast Marketing</li>
            <li>Platform Listing & Optimization</li>
            <li>Media Buying & Planning</li>
          </ul>
        </div>

        {/* SERVICES 2 */}
        <div className="gm-footer-col">
          <h4 className="gm-footer-title">&nbsp;</h4>
          <ul>
            <li>Search Engine Optimization</li>
            <li>Answer Engine Optimization</li>
            <li>Social Media Marketing</li>
            <li>Strategy & Consulting</li>
            <li>Public Relations</li>
            <li>Influencer Marketing</li>
            <li>Video Production</li>
            <li>Brand Kit Design</li>
          </ul>
        </div>

        {/* CONTACT */}
        <div className="gm-footer-col gm-footer-contact">
          <h4 className="gm-footer-title">Contact Us</h4>

          <p>
            Navale Icon,<br />
            Navale Bridge,Wadgaon BK,<br />
            Pune, Maharashtra 411041
          </p>

          <p>+91 00000 00000</p>
          <p>+91 00000 00000</p>
          <p className="gm-footer-email">info@globalmanch.com</p>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="gm-footer-bottom">
        <span>© Global Manch </span>
        <Link to="/contact-us"><button className="gm-footer-cta">
          Contact Us →
        </button></Link>
      </div>
    </footer>
  );
};

export default Footer;
